export default __webpack_public_path__ + "b5d6dd9922ddc70e7c6303486b8b1a00.svg";